import React from "react";
import { Box, FabButton, Flex, Gap, Icon, Typography } from "../../../../ppui";
import { TbBuildingBank, TbCashBanknote, TbCopy, TbCreditCard, TbMapPin } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../../../style";

const BankAccount = () => {
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Bank Account
        </Typography>
        <FabButton
          size="sm"
          icon={<TbCopy />}
          //    onClick={{}}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Icon size={"lg"}>
            <TbBuildingBank />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Bank Name
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Yes Bank
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbMapPin />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Branch Name
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Salt Lake Sec-V
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCreditCard />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Account Number
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              435667845362
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCashBanknote />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              IFSC code
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              SBIN0009890
            </Typography>
          </Box>
        </OrganizationBx>
      </OrganizationEmDetails>
    </>
  );
};

export default BankAccount;
